import { ErrorTemplateBuilder } from '../../infrastructure/error-template-builder';
import type { entityProcessConfig } from '../entity-process/signalr-process-config';
import { Enums } from '../helper/enums';
import { EntityManager } from './entity-manager';

export class SignalRFormService {
    
    public setFormConnectionEvents(connection: signalR.HubConnection) {
        connection.on("formEntitySync", async (message: any) => {
            try {
                await this.formEntitySync(JSON.parse(message));
            } catch (e) {
                console.error(ErrorTemplateBuilder.getCatchText('SignalRFormService.formEntitySync', e));
            }
        });
    }

    private async formEntitySync(message:any){
        try {
            if(message.data){
                message.data.state = 'New';
            }
            const [result, object]: [any, entityProcessConfig | null] = await EntityManager.updateEntity(message, Enums.SignalRMessageType[Enums.SignalRMessageType.FormEntitySync], "Id", message.entityId);
        } catch (e) {
            console.error(ErrorTemplateBuilder.getCatchText('SignalRFormService.formEntitySync', e));
        }
    }
}
